<template>
    <van-popup v-model="active" closeable round safe-area-inset-bottom class="popup-download-tips" position="bottom">
        <div class="title">
            <img class="logo" :src="logo" />
            <div class="main_title">
                <div style="font-size: 18px; font-weight: 700; margin-bottom: 6px">快速添加桌面应用</div>
                <div style="font-size: 12px; color: grey">便捷启动·全屏体验</div>
            </div>
        </div>
        <div class="content">
            <swipe loop class="swipe" indicator-color="white" :autoplay="3000">
                <swipe-item v-for="(img, index) of imgs" :key="index" class="item">
                    <img class="bg" :src="img" />
                </swipe-item>
            </swipe>
        </div>
    </van-popup>
</template>

<script lang="ts">
import { Popup, Swipe, SwipeItem } from 'vant'
import { Component } from 'vue-property-decorator'

import BaseComponent from '@/BaseComponent'

/**
 *
 * @author
 * @create 2021-11-26 (星期五)
 */
@Component({ name: 'popup-download-tips', components: { Swipe, SwipeItem, Popup } })
export default class extends BaseComponent {
    /* props, data, getter */
    /**  */
    active: boolean = false
    callback!: Function
    imgs: Array<string> = []
    logo: string = ''
    /* life event: [mounted, beforeDestory] */
    /* methods */
    /** 打开 */
    async open(imgs: Array<string>, logo: string): Promise<void> {
        return new Promise((resolve) => {
            this.active = true
            this.callback = resolve
            this.imgs = imgs
            this.logo = logo
        })
    }

    /** 关闭 */
    close(): void {
        this.active = false
        this.callback?.()
    }
}
</script>

<style lang="less" scoped>
.popup-download-tips {
    position: fixed;
    z-index: 9;
    left: 0;
    width: 100vw;

    .title {
        display: flex;
        align-items: center;
        color: rgb(0, 0, 0);
        padding: 15px;

        .logo {
            width: 60px;
            height: 60px;
            border-radius: 8px;
            margin-right: 10px;
        }
    }
    .content {
        width: calc(100vw - 30px);
        background: #fff;
        display: flex;
        flex-flow: column nowrap;
        overflow: hidden;
        border-radius: 8px;
        padding: 0 15px 0;

        padding-bottom: calc(constant(safe-area-inset-bottom) + 30px) !important;
        padding-bottom: calc(env(safe-area-inset-bottom) + 30px) !important;

        .bg {
            width: 100%;
            height: 275px;
            object-fit: contain;
        }
    }
}
</style>
